import { render, staticRenderFns } from "./FolderWithBorder.vue?vue&type=template&id=73c36f85&scoped=true"
import script from "./FolderWithBorder.vue?vue&type=script&lang=js"
export * from "./FolderWithBorder.vue?vue&type=script&lang=js"
import style0 from "./FolderWithBorder.vue?vue&type=style&index=0&id=73c36f85&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c36f85",
  null
  
)

export default component.exports